// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-line[data-v-dda43c96]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;height:27px;width:100%;color:var(--q4s-neutral-500);display:flex;align-items:center;margin-bottom:9px}.time-line .hours[data-v-dda43c96]{margin-right:-4px;display:flex;width:100%}", ""]);
// Exports
module.exports = exports;
